import React from 'react';

import type { Dayjs } from 'dayjs';
import dayjs from '~/timeInit';

import { Button, Stack } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers-pro';

const ISO_DATE = 'YYYY-MM-DD';

interface Props {
  dateFrom: string;
  dateTo: string;
  minDate: string;
  maxDate: string;
  onDateFromChange: (next: string) => void;
  onDateToChange: (next: string) => void;
  onReset: () => void;
  resetLabel?: string;
}

function toDayjs(value: string): Dayjs | null {
  return value ? dayjs(value, ISO_DATE) : null;
}

function fromDayjs(value: Dayjs | null): string {
  return value && value.isValid() ? value.format(ISO_DATE) : '';
}

export default function DateRangeRow({
  dateFrom,
  dateTo,
  minDate,
  maxDate,
  onDateFromChange,
  onDateToChange,
  onReset,
  resetLabel = 'Reset to last 12mo',
}: Props) {
  const min = toDayjs(minDate) ?? undefined;
  const max = toDayjs(maxDate) ?? undefined;
  const fromValue = toDayjs(dateFrom);
  const toValue = toDayjs(dateTo);

  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ sm: 'center' }}>
      <DatePicker
        label="From"
        value={fromValue}
        minDate={min}
        maxDate={toValue ?? max}
        format="DD/MM/YYYY"
        onChange={(v) => onDateFromChange(fromDayjs(v))}
        slotProps={{ textField: { size: 'small' } }}
      />
      <DatePicker
        label="To"
        value={toValue}
        minDate={fromValue ?? min}
        maxDate={max}
        format="DD/MM/YYYY"
        onChange={(v) => onDateToChange(fromDayjs(v))}
        slotProps={{ textField: { size: 'small' } }}
      />
      <Button variant="contained" onClick={onReset}>
        {resetLabel}
      </Button>
    </Stack>
  );
}
